/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListNoteConversation } from '../models/api-response-list-note-conversation';
import { ApiResponseLong } from '../models/api-response-long';
import { ApiResponseNoteConversation } from '../models/api-response-note-conversation';
import { createNoteConversation } from '../fn/note-conversation-api/create-note-conversation';
import { CreateNoteConversation$Params } from '../fn/note-conversation-api/create-note-conversation';
import { deleteNoteConversation } from '../fn/note-conversation-api/delete-note-conversation';
import { DeleteNoteConversation$Params } from '../fn/note-conversation-api/delete-note-conversation';
import { getCountByConversationReferenceAndCompanyId } from '../fn/note-conversation-api/get-count-by-conversation-reference-and-company-id';
import { GetCountByConversationReferenceAndCompanyId$Params } from '../fn/note-conversation-api/get-count-by-conversation-reference-and-company-id';
import { listNoteConversationByConvRef } from '../fn/note-conversation-api/list-note-conversation-by-conv-ref';
import { ListNoteConversationByConvRef$Params } from '../fn/note-conversation-api/list-note-conversation-by-conv-ref';

@Injectable({ providedIn: 'root' })
export class NoteConversationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createNoteConversation()` */
  static readonly CreateNoteConversationPath = '/v1/api/ui/note-conversation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNoteConversation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNoteConversation$Response(params: CreateNoteConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseNoteConversation>> {
    return createNoteConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createNoteConversation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNoteConversation(params: CreateNoteConversation$Params, context?: HttpContext): Observable<ApiResponseNoteConversation> {
    return this.createNoteConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseNoteConversation>): ApiResponseNoteConversation => r.body)
    );
  }

  /** Path part for operation `listNoteConversationByConvRef()` */
  static readonly ListNoteConversationByConvRefPath = '/v1/api/ui/note-conversation/list/{convRef}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listNoteConversationByConvRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNoteConversationByConvRef$Response(params: ListNoteConversationByConvRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListNoteConversation>> {
    return listNoteConversationByConvRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listNoteConversationByConvRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNoteConversationByConvRef(params: ListNoteConversationByConvRef$Params, context?: HttpContext): Observable<ApiResponseListNoteConversation> {
    return this.listNoteConversationByConvRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListNoteConversation>): ApiResponseListNoteConversation => r.body)
    );
  }

  /** Path part for operation `getCountByConversationReferenceAndCompanyId()` */
  static readonly GetCountByConversationReferenceAndCompanyIdPath = '/v1/api/ui/note-conversation/count/{convRef}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountByConversationReferenceAndCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountByConversationReferenceAndCompanyId$Response(params: GetCountByConversationReferenceAndCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
    return getCountByConversationReferenceAndCompanyId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountByConversationReferenceAndCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountByConversationReferenceAndCompanyId(params: GetCountByConversationReferenceAndCompanyId$Params, context?: HttpContext): Observable<ApiResponseLong> {
    return this.getCountByConversationReferenceAndCompanyId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLong>): ApiResponseLong => r.body)
    );
  }

  /** Path part for operation `deleteNoteConversation()` */
  static readonly DeleteNoteConversationPath = '/v1/api/ui/note-conversation/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNoteConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNoteConversation$Response(params: DeleteNoteConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteNoteConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNoteConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNoteConversation(params: DeleteNoteConversation$Params, context?: HttpContext): Observable<void> {
    return this.deleteNoteConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
